import React from 'react'
import './TransferAttachment.css'

import TransferHeader from './TransferHeader'
import TransferSidebar from './TransferSidebar'
export default function TransferAttachment() {
  return (
    <> 
    <div className='TransferAttachment'>
   <TransferHeader/>
   
<div class ="jobProcess">
    <TransferSidebar/>
    <div class ="Attachment">
        <h1>Documents</h1>
        <button className='Add'>Add</button>
        
    </div></div>
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
          
        </div>
        </div>
        </>
  )
}
